import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ConnectionSetupTableRow } from 'components/ConnectionSetupTable/ConnectionSetupTable';
import { StepStatus } from 'components/Display/Steps/Steps';

type Params = {
  stepStatus: StepStatus;
};

export const useConfigurationStep = ({ stepStatus }: Params) => {
  const { t } = useTranslation();

  const rows: Array<ConnectionSetupTableRow> = useMemo(
    () => [
      {
        id: 'technical-configuration',
        status: stepStatus === 'completed' ? 'DONE' : 'TODO',
        title: t('connections:relationshipDetails.steps.configuration.tasks.technicalConfiguration'),
        ownership: 'procuros',
        actionRequired: false,
      },
    ],
    [stepStatus, t],
  );

  return { rows };
};
